import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { accessLocalStorage, exportSelectAllQueues, exportDeleteQueues } from '../../../services';
import { scopeByTenant } from '../../../services/tenantScope';
import { hasFeature } from '../../../services/permissions';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';
import './QueuesList.css';

import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faUsers } from '@fortawesome/free-solid-svg-icons';

function QueuesList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { setItemsSelectedToEdit } = getItensStateGlobal;

  const [loading, setLoading] = useState(true);
  const [queuesLocal, setQueuesLocal] = useState(() => []);
  const [queuesSelected, setQueuesSelected] = useState('');
  const [disable, setDisable] = useState(true);
  const [deleting, setDeleting] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const history = useHistory();

  const fetchQueues = async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { idtenant } } = dataUser;
    let queuesList = await exportSelectAllQueues();
    if(queuesList === undefined) setLoading(true);
    queuesList = scopeByTenant(queuesList, (queue) => queue.accountcodequeue, idtenant);
    const elements = queuesList.map((element) => element.namequeue);
    setQueuesLocal(elements);
    setLoading(false);
    return true;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');

    const queuesFetched = await fetchQueues();
    return queuesFetched;
  }, []);

  const handleChangeSelectedQueues = (element) => {
    setQueuesSelected(element);
    setDisable(element.length === 0);
  };

  const handleClickDelete = async () => {
    setDeleting(true);
    setAlert({ show: false, type: '', message: '' });

    const result = await exportDeleteQueues({ queue: queuesSelected });

    setDeleting(false);
    setConfirmDelete(false);

    if (!result.success) {
      setAlert({ show: true, type: 'danger', message: result.error });
      return;
    }

    setAlert({ show: true, type: 'success', message: 'Fila excluída com sucesso!' });
    setQueuesSelected('');
    setDisable(true);
    await validateUserLogged();
  };

  const handleClickUpdate = async () => {
    setItemsSelectedToEdit(queuesSelected);
    return history.push('/config/fila/lista/nome');
  };

  const openMembers = (event, name) => {
    event.preventDefault();
    event.stopPropagation();
    history.push(`/config/fila/membros/gerenciar?fila=${encodeURIComponent(name)}`);
  };

  const canEditMembers = hasFeature('config.filas', 'edit');

  const filteredQueues = queuesLocal.filter((queue) => {
    const searchText = filterText.toLowerCase();
    return queue.toLowerCase().includes(searchText);
  });

  useEffect(() => {
    let cancel = false;

    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div className="queues-list-container">
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="queues-list-header">
            <div className="queues-list-title-wrapper">
              <svg className="queues-list-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <div>
                <h1 className="queues-list-title">Filas</h1>
                <p className="queues-list-subtitle">Gerencie os grupos atendedores</p>
              </div>
            </div>
          </div>

          {alert.show && (
            <div className="alerts-section">
              <div className={`alert-message alert-${alert.type}`}>
                <div className="alert-header">
                  <span>{alert.type === 'success' ? 'Sucesso!' : 'Erro!'}</span>
                  <button className="alert-close" aria-label="delete" onClick={() => setAlert({ show: false, type: '', message: '' })}>×</button>
                </div>
                <div className="alert-body">
                  {alert.message}
                </div>
              </div>
            </div>
          )}

          {confirmDelete && (
            <div className="alerts-section">
              <div className="alert-message alert-danger">
                <div className="alert-header">
                  <span>Atenção!</span>
                  <button className="alert-close" aria-label="delete" onClick={() => setConfirmDelete(false)}>×</button>
                </div>
                <div className="alert-body">
                  Tem certeza que quer deletar a fila selecionada?
                  <div className="alert-actions">
                    <button className="btn-alert btn-alert-confirm" type="submit" onClick={() => handleClickDelete()} disabled={deleting}>
                      <FontAwesomeIcon icon={faTrash} />
                      <span>{deleting ? 'Excluindo...' : 'Confirmar'}</span>
                    </button>
                    <button className="btn-alert btn-alert-cancel" type="submit" onClick={() => setConfirmDelete(false)} disabled={deleting}>
                      <FontAwesomeIcon icon={faTrash} />
                      <span>Cancelar</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="filter-section">
            <div className="filter-input-wrapper">
              <svg className="filter-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                className="filter-input"
                placeholder="Filtrar filas..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              {filterText && (
                <button className="filter-clear" onClick={() => setFilterText('')}>
                  ×
                </button>
              )}
            </div>
            <div className="filter-results">
              Exibindo {filteredQueues.length} de {queuesLocal.length} fila(s)
            </div>
          </div>

          <div className="queues-panel">
            <p className="queues-panel-heading">Filas</p>
            {filteredQueues.map((phone) => {
              return (
                <label className="queues-panel-block" key={phone}>
                  <input name="name-queue" type="radio" value={phone} checked={queuesSelected === phone} onChange={(e) => handleChangeSelectedQueues(e.target.value)} />
                  <span>{phone}</span>
                  {canEditMembers && (
                    <button className="btn-queue-action btn-queue-members" type="button" aria-label={`Membros da fila ${phone}`} onClick={(event) => openMembers(event, phone)}>
                      <FontAwesomeIcon icon={faUsers} />
                      <span>Membros</span>
                    </button>
                  )}
                </label>
              );
            })}
          </div>

          {!confirmDelete && (
            <div id="buttons" className="queues-actions">
              <button className="btn-queue-action btn-view-queue" type="submit" onClick={() => handleClickUpdate()} disabled={disable}>
                <FontAwesomeIcon icon={faPen} />
                <span>Visualizar</span>
              </button>
              {hasFeature('config.filas', 'delete') && (
                <button
                  className="btn-queue-action btn-delete-queue"
                  type="submit"
                  onClick={() => setConfirmDelete(true)}
                  disabled={disable}
                >
                  <FontAwesomeIcon icon={faTrash} />
                  <span>Deletar</span>
                </button>
              )}
            </div>
          )}
        </div>
      }
    </div>
  );
}

export default QueuesList;
